const textToError = text => (text ? { error: true, helperText: text } : {})

export default textToError
